import LogService from "../CommonSdk/LogService";
import * as ErrorUtils from "../Utils/ErrorUtils";
import RainbowServerFetch from "../Request/RainbowServerFetch";

const LOG_TAG = "SERVICE:FILESTORAGE";

export const getFileDescriptor = (fileId) => {
    LogService.trace(LOG_TAG, "GetFileDescriptor", "enter");

    return RainbowServerFetch.get("/api/rainbow/filestorage/v1.0/files/" + fileId)
        .then(json => {
            return Promise.resolve(json.data);
        })
        .catch(error => {
            LogService.error(LOG_TAG, "GetFileDescriptor", "error", error);
            return Promise.reject(ErrorUtils.parseErrorAndReturnPayload(error));
        });
}

export const getFileDescriptorList = (fileIdList) => {
    LogService.trace(LOG_TAG, "GetFileDescriptorList", "enter");

    let dataRequests = [];
    
    fileIdList.forEach((fileId) => {
        dataRequests.push(getFileDescriptor(fileId.id))
    })

    return Promise.all(dataRequests)
}

export const getFileDescriptorByViewerId = (viewerId) => {
    LogService.trace(LOG_TAG, "GetFileDescriptorByViewerId", "enter");
    return RainbowServerFetch.get("/api/rainbow/filestorage/v1.0/files/viewers/" + viewerId)
        .then(json => {
            LogService.info(LOG_TAG, "GetFileDescriptorByViewerId");
            return Promise.resolve(json);
        })
        .catch(error => {
            LogService.error(LOG_TAG, "GetFileDescriptorByViewerId", "error", error);
            return Promise.reject(ErrorUtils.parseErrorAndReturnPayload(error));
        });
}

export const GetBackendTempURL = (fileId) => {
    LogService.trace(LOG_TAG, "GetBackendTempURL", "enter");

    return RainbowServerFetch.get("/api/rainbow/fileserver/v1.0/files/" + fileId + "/temporary-url")
        .then(json => {
            LogService.info(LOG_TAG, "GetBackendTempURL", "url=", json.data);
            return Promise.resolve(json.data);
        })
        .catch(error => {
            LogService.error(LOG_TAG, "GetBackendTempURL", "error", error);
            return Promise.reject(ErrorUtils.parseErrorAndReturnPayload(error));
        });
}

export const GetBackendTempURLList = (listFileId) => {
    LogService.trace(LOG_TAG, "GetBackendTempURLList", "enter");  

    let dataRequests = [];
        
    listFileId.forEach((fileId) => {
        dataRequests.push(GetBackendTempURL(fileId.id));
    })

    return Promise.all(dataRequests)
}